export default "__VITE_ASSET__BnmJvW_h__"